import type { NlRcphArchiSubSegment, NlRcphSubSegment } from './nl-rcph-activity-configuration.ts'

export const NL_RCPH_ARCHI_CIVIL_PI_DEDUCTIBLE = 1_500 as const
export const NL_RCPH_ARCHI_INTERIOR_PI_DEDUCTIBLE = 1_000 as const

export const nlRcphArchiCivilSubSegments = [
  'Bouwkundig teken- en adviesbureau',
  'Architectenbureau',
] as const satisfies readonly NlRcphArchiSubSegment[]

export const nlRcphArchiInteriorSubSegments = ['Interieurarchitect'] as const satisfies readonly NlRcphArchiSubSegment[]

export type NlRcphResolvedActivity = {
  readonly activityId: string
  readonly subSegment: NlRcphSubSegment | undefined
}

// TODO (NL-RCPH): drop with `withNlRcphFallbackArchiSubSegment` once no NL-RCPH archi state is left without a
// sub-segment: nlRcphActivitiesConfigurations should be updated for existing subscriptions
const nlRcphFallbackArchiSubSegmentByActivityId: Partial<Record<string, NlRcphArchiSubSegment>> = {
  act_01kt1ank20f6a9m0t4fbtcsg35: 'Bouwkundig teken- en adviesbureau',
  act_01kt1ank20f6a9m0tcnpgay5vw: 'Architectenbureau',
  act_01kt1ank20f6a9m0tkkmr6zwq4: 'Interieurarchitect',
}

export function withNlRcphFallbackArchiSubSegment(
  activities: readonly NlRcphResolvedActivity[],
): NlRcphResolvedActivity[] {
  return activities.map((activity) =>
    activity.subSegment
      ? activity
      : { ...activity, subSegment: nlRcphFallbackArchiSubSegmentByActivityId[activity.activityId] },
  )
}

export function findNlRcphArchiCivilSubSegment(
  activities: readonly NlRcphResolvedActivity[],
): NlRcphArchiSubSegment | undefined {
  return nlRcphArchiCivilSubSegments.find((civilSubSegment) =>
    activities.some(({ subSegment }) => subSegment === civilSubSegment),
  )
}

function hasNlRcphArchiInteriorFamily(activities: readonly NlRcphResolvedActivity[]): boolean {
  return activities.some(({ subSegment }) =>
    nlRcphArchiInteriorSubSegments.some((interiorSubSegment) => interiorSubSegment === subSegment),
  )
}

export function isNlRcphArchiInteriorOnly(activities: readonly NlRcphResolvedActivity[]): boolean {
  // TODO (NL-RCPH): inline `activities` once every ARCHI subscription carries its sub-segment.
  const resolvedActivities = withNlRcphFallbackArchiSubSegment(activities)
  return (
    hasNlRcphArchiInteriorFamily(resolvedActivities) && findNlRcphArchiCivilSubSegment(resolvedActivities) === undefined
  )
}

export function getNlRcphArchiPiDeductible(activities: readonly NlRcphResolvedActivity[]): number {
  if (isNlRcphArchiInteriorOnly(activities)) {
    return NL_RCPH_ARCHI_INTERIOR_PI_DEDUCTIBLE
  }
  return NL_RCPH_ARCHI_CIVIL_PI_DEDUCTIBLE
}
